<template>
  <div class="">
    <!--<div class="text-secondary_text py-2">
      {{this.index + 1}} di 2
    </div>
    -->
    <div>
      {{questionText}}
    </div>

    <div class="flex flex-col">
        
      <template v-if="index < 1">
        <check-button
          v-for="answer in question.answers"
          :key="answer"
          @input="$set(knownTerms, answer, $event)"
          :value="knownTerms[answer]"
          >{{answer}}</check-button>

        <check-button
          v-for="(term, i) in personalKnownTerms"
          :key="term"
          :value="true"
          @input="personalKnownTerms.splice(i, 1)"
          >{{term}}</check-button>
        
        <inline-prompt
          :addButtonText="$t('surveys.add-known-term')"
          :placeholder="$t('surveys.known-term')"
          :saveButtonText="$t('add')"
          @input="addKnownTerm($event)"
        />
        <button class="btn btn-1 my-2" :disabled="knownTermsArray.length == 0 && personalKnownTerms.length == 0" @click="showUsedOrSend()">{{$t('continue')}}</button>
      </template>
      <template v-else>
        <check-button
          v-for="([answer]) in Object.entries(knownTerms).filter(([k, v]) => v)"
          :key="answer"
          @input="$set(usedTerms, answer, $event)"
          :value="usedTerms[answer]"
          >{{answer}}</check-button>
        
        <check-button
          v-for="answer of personalKnownTerms"
          :key="answer + '_personal'"
          @input="$set(personalUsedTerms, answer, $event)"
          :value="personalUsedTerms[answer]"
          >{{answer}}</check-button>

        <button class="btn btn-1 my-2" :disabled="usedTermsArray.length == 0 && personalUsedTermsArray == 0" @click="send()">{{$t('continue')}}</button>
      </template>
    </div>
  </div>

</template>

<script>
import CheckButton from '@/components/CheckButton'
import InlinePrompt from '@/components/InlinePrompt';

export default {
  data() {
    const a = this.answer || {}
    return {
      index: -1,
      personalKnownTerms: Array.isArray(a['personal']) ? a['personal'] : [],
      knownTerms: Array.isArray(a['known']) ? a['known'].reduce((acc, cur) => {acc[cur] = true; return acc}, {}) : {},
      usedTerms: Array.isArray(a['used']) ? a['used'].reduce((acc, cur) => {acc[cur] = true; return acc}, {}) : {},
      personalUsedTerms: Array.isArray(a['personalUsed']) ? a['personalUsed'].reduce((acc, cur) => {acc[cur] = true; return acc}, {}) : {},
    }
  },

  components: {
    CheckButton: CheckButton,
    InlinePrompt: InlinePrompt
  },

  props: {
    question: Object,
    answer: Object,
  },
  
  mounted() {
    setTimeout(() => {
      this.index = 0
    }, 0);
  },

  computed: {
    knownTermsArray() {
      return Object
        .entries(this.knownTerms)
        .filter(([,v]) => v)
        .map(([k,]) => k)
        .sort((a, b) => this.question.answers.indexOf(a) - this.question.answers.indexOf(b))
    },
    personalUsedTermsArray() {
      return Object
        .entries(this.personalUsedTerms)
        .filter(([,v]) => v)
        .map(([k,]) => k)
    },
    usedTermsArray() {
      return Object
        .entries(this.usedTerms)
        .filter(([,v]) => v)
        .map(([k,]) => k)
        .sort((a, b) => this.question.answers.indexOf(a) - this.question.answers.indexOf(b))
    },
    options() {
      return Object.fromEntries(this.question.answers.map(o => [o, o]))
    },
    questionText() {
      if(this.index == 0) {
        return this.question.question_know
      } else {
        return this.question.question_use
      }
    },
    completeness() {
      return (this.index+1) / 2
    }
  },

  methods: {
    showUsedOrSend() {
      if(this.knownTermsArray.length === 1 && this.personalKnownTerms.length === 0) {
        this.$set(this.usedTerms, this.knownTermsArray[0], true)
      }
      if(this.knownTermsArray.length + this.personalKnownTerms.length > 1) {
        this.index = 1
      } else {
        this.send()
      }
    },
    addKnownTerm(term) {
      if(term && term.trim().length > 0) {
        this.personalKnownTerms.push(term.trim())
      }
    },
    send() {
      const answer = Object.create(null)
      answer['known'] = this.knownTermsArray
      answer['personal'] = [...this.personalKnownTerms]
      answer['used'] = this.usedTermsArray
      answer['personalUsed'] = [...this.personalUsedTermsArray]

      this.$emit('input', answer)
    }
  }
}
</script>

<style scoped>
.animated-stroke {
  transition: stroke-dashoffset 500ms ease-in-out;
}
</style>